<script setup>
import SearchInput from "~/components/ui/SearchInput.vue";
import MainNav from "~/components/public/MainNav.vue";
const publicSiteData = useState('publicSiteData');
const mobileNavOpen = ref(false);
const route = useRoute();

// Close mobile nav when route changes
watch(() => route.path, () => {
    mobileNavOpen.value = false;
});
</script>

<template>
    <div>
        <header class="px-6 border-b border-gray-400">
            <div class="max-w-5xl mx-auto py-4 flex items-center sm:gap-x-4 md:gap-12 tracking-wide">

                <div class="flex gap-4 items-center">
                    <div class="w-12 h-10 hidden sm:inline-block">
                        <img v-if="publicSiteData.logo" :src="publicSiteData.logo" class="object-contain w-full h-full" alt="Organization logo" />
                    </div>
                    <button @click="() => mobileNavOpen = true" class="block sm:hidden" aria-label="Open navigation menu" :aria-expanded="mobileNavOpen">
                        <font-awesome :icon="['far', 'bars']" aria-hidden="true"></font-awesome>
                    </button>
                    <div class="text-lg font-bold">{{ publicSiteData.organization_display_name }}</div>
                </div>

                <MainNav class="hidden sm:block"></MainNav>

                <SearchInput rounded class="ml-auto hidden sm:flex"/>
            </div>
        </header>
        <div v-show="mobileNavOpen" class="fixed sm:hidden inset-0 bg-white z-10 flex flex-col">
            <button @click="() => mobileNavOpen = false" class="absolute top-4 right-4 z-20 p-2 text-gray-900" aria-label="Close navigation menu">
                <font-awesome :icon="['fas', 'xmark-large']" aria-hidden="true"></font-awesome>
            </button>
            <div class="p-6 mt-4">
                <MainNav class="flex flex-col" :mobile="true"></MainNav>
            </div>
        </div>
    </div>
</template>
